import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getTahunAkhirByNim = createAsyncThunk("tahunAkhir/getTahunAkhirByNim", async(nim) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/akm/tahun-akhir/${nim}`);
    return response.data;
});

const initialState = {
    dataTahunAkhir: null,
    loadingTahunAkhir: false,
}

const tahunAkhirSlice = createSlice({
    name: "tahunAkhir",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTahunAkhirByNim.pending, (state) => {
                state.loadingTahunAkhir = true;
            })
            .addCase(getTahunAkhirByNim.fulfilled, (state, action) => {
                state.dataTahunAkhir = action.payload;
                state.loadingTahunAkhir = false;
            })
            .addCase(getTahunAkhirByNim.rejected, (state) => {
                state.loadingTahunAkhir = false;
            })
    }
})

export const tahunAkhirSelectors = (state) => state.tahunAkhir;
export default tahunAkhirSlice.reducer;
